import React from 'react';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
import KeywordContainer from '../../../Containers/AdminContainer/Keywords';

const KeywordScreen = () => {
  return <KeywordContainer />;
};

export default KeywordScreen;
